'use strict';

var _require = require('./Component');

var DebounceInput = _require.DebounceInput;


module.exports = DebounceInput;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-debounce-input/lib/index.js
// module id = 1695
// module chunks = 1